import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { completedTableConfig } from "../../../config/tables/superadmin/completedTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface CompletedTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function CompletedTabComponent(props: CompletedTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={completedTableConfig}
      tabType="completed"
    />
  );
}

export const CompletedTab = memo(CompletedTabComponent);
